__turbopack_context__.v({
  "ad": "NKv-rq_ad",
  "container": "NKv-rq_container",
  "list": "NKv-rq_list",
});
